import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "@/lib/api";

const Terms = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/terms`);
        if (res.ok) {
          const data = await res.json();
          setContent(data.content || "Terms and conditions will be updated soon.");
        }
      } catch (_error) {
        // silently ignore — fallback content already set
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#0f0f0f" }}>
      <div className="max-w-2xl mx-auto px-5 py-8">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-white/50 hover:text-white/70 mb-6 inline-flex items-center gap-1"
        >
          ← Back
        </button>
        <h1 className="text-xl font-bold text-white mb-6">Terms & Conditions</h1>
        {loading ? (
          <div className="flex justify-center py-16">
            <div className="w-6 h-6 border-2 border-[#01ff9a] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div className="text-sm text-white/70 leading-relaxed whitespace-pre-wrap">{content}</div>
        )}
      </div>
    </div>
  );
};

export default Terms;
